<script>
export default {
    name: "TestEnvironmentBadge",
    computed: {
        isTestEnvironment() {
            return process.env.VUE_APP_TEST_ENV === "true";
        }
    }
}
</script>

<template>
    <div v-if="isTestEnvironment" class="test-environment-badge" role="status">
        {{ $t('topBar.testEnvironment') }}
    </div>
</template>

<style lang="scss" scoped>
.test-environment-badge {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: $z-quick-menu + 1;
    padding: 2px $default-edge-spacing-l;
    border-radius: 0 0 $radius-small $radius-small;
    background: $color-primary-blue;
    color: $color-primary-back;
    font-size: $font-small;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    white-space: nowrap;
    pointer-events: none;
    user-select: none;
}
</style>
